export const processDate = (data) => {
  let formattedDate;
  const receivedDate = new Date(data * 1000);
  let time = receivedDate.toLocaleTimeString();
  let day = receivedDate.toLocaleString("en-US", { weekday: "short" });
  let date = receivedDate.toLocaleString("en-US", { day: "numeric" });
  let month = receivedDate.toLocaleString("en-US", { month: "short" });
  let year = receivedDate.toLocaleString("en-US", { year: "numeric" });
  formattedDate =
    year +
    "-" +
    day +
    "-" +
    date +
    "-" +
    month +
    " " +
    receivedDate.getHours() +
    ":" +
    receivedDate.getMinutes();
  return formattedDate;
};

export const formatAmountWithCommas = (amount) => {
  if (typeof amount !== "number") return amount;
  const formatValue = (value, suffix, noSpace = false) => {
    const formatted = value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
    return noSpace ? formatted + suffix : formatted + " " + suffix;
  };

  if (amount >= 10000000) {
    return formatValue(amount / 10000000, "Crore");
  } else if (amount >= 100000) {
    return formatValue(amount / 100000, "Lakh");
  } else if (amount >= 1000) {
    return formatValue(amount / 1000, "K", true);
  }
  return amount.toLocaleString("en-IN");
};
